import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["appState", "areBothGoogleAuth", "backupCodesEnabled", "callForCode", "hasSecondaryMethod", "lastFour", "onLostDevice", "retryCode", "switchAppState", "switchVerificationMethod", "twoFactorAuthMethod", "onRestartTimer"];
import { useCallback } from 'react';
import { HR } from 'foundations-components/transitional/components/HR';
import { View } from 'foundations-components/transitional/components/View';
import TwoFactorAuthMethods from 'LoginUI/constants/TwoFactorAuthMethods';
import TwoFactorAuthAppStates from 'LoginUI/constants/TwoFactorAuthAppStates';
import { TwoFactorAlerts } from './TwoFactorAlerts';
import { use2faAlerts } from './hooks/use2faAlerts';
import { BackupCodesModal, NeedHelp, TwoFactorSmsForm, TwoFactorAuthenticatorAppForm, TwoFactorHubspotAppForm } from 'two-factor-prompt-lib/components/shared';
import { LoginApplication } from '../LoginApplication';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TwoFactorAuthVerifyV4 = _ref => {
  let {
      appState,
      areBothGoogleAuth,
      backupCodesEnabled,
      callForCode,
      hasSecondaryMethod,
      lastFour,
      onLostDevice,
      retryCode,
      switchAppState,
      switchVerificationMethod,
      twoFactorAuthMethod,
      onRestartTimer
    } = _ref,
    codeEntryFormProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const toggleBackupCodesModal = useCallback(() => {
    switchAppState();
  }, [switchAppState]);
  const {
    isInvalidCodeAlertVisible,
    hideInvalidCodeAlert
  } = use2faAlerts();
  if (!twoFactorAuthMethod) {
    return null;
  }
  const backupModalOpen = appState === TwoFactorAuthAppStates.BACKUP;
  return /*#__PURE__*/_jsxs(LoginApplication, {
    inlineSize: "480px",
    children: [/*#__PURE__*/_jsx(TwoFactorAlerts, {
      onRestartTimer: onRestartTimer
    }), /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      children: [twoFactorAuthMethod === TwoFactorAuthMethods.SMS && /*#__PURE__*/_jsx(TwoFactorSmsForm, Object.assign({
        handleCallForCode: callForCode,
        lastFour: lastFour,
        onResendCode: retryCode,
        isModalOpen: backupModalOpen,
        isInvalidCodeAlertVisible: isInvalidCodeAlertVisible,
        hideInvalidCodeAlert: hideInvalidCodeAlert
      }, codeEntryFormProps)), twoFactorAuthMethod === TwoFactorAuthMethods.GOOGLE_AUTHENTICATOR && /*#__PURE__*/_jsx(TwoFactorAuthenticatorAppForm, Object.assign({
        isModalOpen: backupModalOpen,
        isInvalidCodeAlertVisible: isInvalidCodeAlertVisible,
        hideInvalidCodeAlert: hideInvalidCodeAlert
      }, codeEntryFormProps)), twoFactorAuthMethod === TwoFactorAuthMethods.HUBSPOT_AUTHENTICATOR && /*#__PURE__*/_jsx(TwoFactorHubspotAppForm, Object.assign({
        isInvalidCodeAlertVisible: isInvalidCodeAlertVisible,
        hideInvalidCodeAlert: hideInvalidCodeAlert
      }, codeEntryFormProps, {
        type: "modal"
      })), /*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(NeedHelp, {
        onLostDevice: onLostDevice,
        onChangePrecedence: hasSecondaryMethod && !areBothGoogleAuth ? switchVerificationMethod : undefined,
        toggleBackupCodesModal: backupCodesEnabled ? toggleBackupCodesModal : undefined
      })]
    }), backupModalOpen && /*#__PURE__*/_jsx(BackupCodesModal, Object.assign({
      toggleBackupCodesModal: toggleBackupCodesModal,
      isInvalidCodeAlertVisible: isInvalidCodeAlertVisible,
      hideInvalidCodeAlert: hideInvalidCodeAlert
    }, codeEntryFormProps))]
  });
};